var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2608_75763)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.16699,
    cy: 9.16669,
    r: 7.5,
    stroke: "#28475C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1764 17.479C18.1241 17.5579 18.0297 17.6523 17.8408 17.8411C17.652 18.03 17.5576 18.1244 17.4787 18.1767C17.0165 18.4827 16.3913 18.325 16.1296 17.8363C16.0849 17.7529 16.0466 17.625 15.97 17.3691C15.8862 17.0896 15.8443 16.9498 15.8362 16.8515C15.7885 16.2723 16.272 15.7889 16.8512 15.8365C16.9495 15.8446 17.0893 15.8865 17.3688 15.9703C17.6247 16.0469 17.7526 16.0853 17.836 16.1299C18.3247 16.3916 18.4824 17.0168 18.1764 17.479Z",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_75763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/Magnifier.61e64b5118a81384517d53792ef82774.svg";
export { ForwardRef as ReactComponent };